import React from 'react';
import { useAdminUsersQuery } from 'api';
import { Select, SelectProps } from 'components';

export const AdminsSelect: React.FC<SelectProps> = React.memo((props) => {
  const { data: admins } = useAdminUsersQuery();

  return (
    <Select
      options={admins}
      showSearch
      filterOption={(input, option) => option?.label?.toString().toLowerCase().includes(input.toLowerCase()) ?? false}
      {...props}
    />
  );
});
